import { Component,  EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';

import { 
  SharedDataService,
  SuppliersService,
  LoggedUserService,
  Supplier,
  DocumentsService,
  PS_Supplier_Purchase_Docs_Result,
  SupplierPurchaseComment,
  PS_PAF_LISTE_EVF_ECF_RAI_Result,
  SimpleReponseResult
 } from 'ngx-paf-common';
import { forkJoin, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { PilotageEndelTabComponent } from '../pilotage-endel-tab/pilotage-endel-tab.component';

@Component({
  selector: 'pilotage-suivi-qualite',
  templateUrl: './pilotage-suivi-qualite.component.html',
  styleUrls: ['./pilotage-suivi-qualite.component.scss'],
  providers: [DatePipe]
})
export class PilotageSuiviQualiteComponent
  extends PilotageEndelTabComponent 
  implements OnInit {


  reloadTab(): void {
    this.loading=true;
    forkJoin([
      this.reloadSupplier(),
      this.suppliersSvc.GetMoovAppsEvfs(this.supplierId)
    ])
    .subscribe(results=>{
        this.supplier = results[0];
        this.lstMoovAppsEvfs = results[1];
        this.lstMoovAppsEvfs.sortOnDateDesc('DateDoc');
        this.loading=false;
      });
  }

  @ViewChild('frmSuiviQualite') frmSuiviQualite: NgForm;

  
  supplier?:Supplier = null;
  supplierDocs:PS_Supplier_Purchase_Docs_Result[]=[];
  lstDocsQual:PS_Supplier_Purchase_Docs_Result[]=[];
  lstMoovAppsEvfs : PS_PAF_LISTE_EVF_ECF_RAI_Result[]=[];
  emptyComment:SupplierPurchaseComment=new SupplierPurchaseComment();
  
  lstFlags:any[]=[
    {text:'Non flagué',value:0, class:'indicateur-nc'},
    {text:'Vert',value:1, class:'indicateur-vert'},
    {text:'Orange',value:2, class:'indicateur-orange'},
    {text:'Rouge',value:3, class:'indicateur-rouge'},
  ];

  
  get selectedFlag(): any{
      return this.lstFlags.find(item=> (this.supplier?.QualityFlagId||0)==item.value);
  }
  set selectedFlag (item:any){
    if (!this.supplier) return;
    this.supplier.QualityFlagId = (item?.value||0);
    this.frmSuiviQualite?.form?.controls['QualityComments'].updateValueAndValidity();
    this.frmSuiviQualite?.form?.updateValueAndValidity();
  }

  constructor(
    public sharedDataSvc:SharedDataService,
    private suppliersSvc:SuppliersService,
    private documentsSvc: DocumentsService,
    public datepipe: DatePipe) { 
      super(sharedDataSvc);
    }

  ngOnInit(): void {  
   this.reloadTab();
  }

  getMoovAppsList(code:string):string[]{
    return this.lstMoovAppsEvfs
      .filter(item=>(item.Reference||'').indexOf(code)==0)
      .map(item=>{
        let ret: string = item.Reference+' - '+ this.datepipe.transform(item.DateDoc, 'dd/MM/yyyy');
        if (code=='EVF'){
          ret+= ' - '+ Math.round(item.NoteGlobale).toString()+'%';
        }
        return ret;
      });
  }
  
  refreshSupplier(stopEditMode:boolean):void{
    this.sharedDataSvc.WindowLock();
      this.reloadSupplier().subscribe(result=>{
        this.supplier = result;
        if (stopEditMode) this.editMode = false;
        this.sharedDataSvc.WindowUnlock();
      });
  }
  
  reloadSupplier():Observable<Supplier>{
    if (!this.supplierId) return of(null);
    this.loading = true;
    return this.suppliersSvc.getSupplier(this.supplierId)
    .pipe(tap((supp:Supplier)=>{
      this.initemptyComment();
      this.reloadDocs();
      this.frmSuiviQualite?.form.markAsPristine();
      this.loading = false;
    }));
  }

  
  get lstQualityComments():SupplierPurchaseComment[]{
    return (this.supplier?.SupplierPurchaseComments || []).filter(c=>c.Screen=='pilotage/qualite');
  }
  
  initemptyComment():void {
    this.emptyComment = new SupplierPurchaseComment();
    this.emptyComment.Screen='pilotage/qualite';
    this.emptyComment.SupplierId = this.supplierId;
  }
  
  reloadDocs():void {
    this.documentsSvc.getSupplierPurchaseDocs(this.supplierId)
       .subscribe(res=>{
         this.supplierDocs = res;
         this.lstDocsQual =this.supplierDocs.filter(d=>d.Cod == 'DOCUMENT_QUALITE');
         this.lstDocsQual.forEach(d=>d.DocId = (d.DocId||0));
         this.lstDocsQual.sortObjectDesc('DocId');
      });
  }

  get noDocQual():boolean {
    return !this.lstDocsQual.some(d=>(d.FullPath||'')!='');
  }
  
  onDocQualChanged(doc:PS_Supplier_Purchase_Docs_Result):void {
    this.reloadDocs();
  }

  onAddComment(commentaire:SupplierPurchaseComment):void {
    if (!commentaire || !commentaire.SupplierId || !commentaire.Comment ){
      return;
    }
    this.sharedDataSvc.WindowLock();
    this.suppliersSvc.addPurchaseComment(commentaire)
    .subscribe((res:SimpleReponseResult)=>{
        this.sharedDataSvc.WindowUnlock();
        if (!res.Ok){
          this.sharedDataSvc.alert(res.Message);
        } else {
          this.suppliersSvc.getSupplier(this.supplierId)
          .subscribe(res=>{
            this.supplier.SupplierPurchaseComments=res.SupplierPurchaseComments;
            this.initemptyComment();
          });
        }
    },
    (error:any)=> this.sharedDataSvc.alert(error.Message || error)
    );
  }

  onDelComment(commentaire:SupplierPurchaseComment):void {
    if (!commentaire?.Id) {
      return;
    }
    this.sharedDataSvc.WindowLock();
    this.suppliersSvc.delPurchaseComment(commentaire.SupplierId,commentaire.Id)
    .subscribe((res:SimpleReponseResult)=>{
      this.sharedDataSvc.WindowUnlock();
        if (!res.Ok){
          this.sharedDataSvc.alert(res.Message);
        } else {
          this.suppliersSvc.getSupplier(this.supplierId)
          .subscribe(res=>{
            this.supplier.SupplierPurchaseComments=res.SupplierPurchaseComments;
            this.initemptyComment();
          });
        }
    },
    (error:any)=> this.sharedDataSvc.alert(error.Message || error)
    );
  }

  get canUpdateFlag():boolean {
    if (!this.editMode) return false;
    return this.canUpdateSuiviQualite;
  }

  get canUpdateComment():boolean {
    if (!this.editMode) return false;
    return this.canUpdateSuiviQualite;
  }
  get canAddDocQuality():boolean {
    if (!this.editMode) return false;
    return this.canUpdateSuiviQualite;
  }
  get canUpdateSuiviQualite():boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('PilotageENDEL_UpdateSuiviQualite');
  }



  supplierBkp:Supplier = null;
  btnEditModifQualiteClick():void {
    this.supplierBkp = Object.assign({},this.supplier);
    this.editMode = true;
  }
  btnAnnuleModifQualiteClick():void {
    this.supplier = Object.assign({},this.supplierBkp);
    this.supplierBkp=null;
    this.editMode = false;
  }

  btnValidModifQualiteClick():void {
     
     this.sharedDataSvc.WindowLock();
      this.suppliersSvc.PostUpdateQualityFlag(this.supplierId,this.selectedFlag.value, this.selectedFlag.value== 0 ? '' : this.supplier?.QualityComments)
      .subscribe(result=>{
        if (!result.Ok){
          this.sharedDataSvc.alert(result.Message);
        } else {
          this.refreshSupplier(true);
        }
      });
  }


  get btnValidModifQualiteDisabled():boolean {
    return this.frmSuiviQualite.invalid;
  }

}
